var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('header',[_c('nav',{staticClass:"navbar navbar-expand-sm navbar-dark bg-dark mb-5"},[_c('div',{staticClass:"container"},[_c('a',{staticClass:"navbar-brand",attrs:{"href":"#"}},[_c('i',{staticClass:"fab fa-youtube fa-2x"}),_c('span',{staticClass:"ml-3"},[_vm._v("Quick Search")])])])])])
}]

export { render, staticRenderFns }